import { useIntl } from 'react-intl';

import './index.scoped.scss';
import Button from '../button/Button';

const Failure = () => {
    const intl = useIntl();

    return (
        <div className={'failure'}>
            <div className={'failure__big'}>{intl.formatMessage({ id: 'general.ops', defaultMessage: 'Hoppla...' })}</div>

            <div className={'failure__headline'}>
                {intl.formatMessage({ id: 'general.errorOccurred', defaultMessage: 'Ein Fehler ist aufgetreten' })}
            </div>

            <Button className={'failure__link'} onClick={() => window.location.reload()}>
                {intl.formatMessage({
                    id: 'general.tryLoadPage',
                    defaultMessage: 'Versuchen Sie, die Seite neu zu laden',
                })}
            </Button>
        </div>
    );
};

export default Failure;
